import { render, staticRenderFns } from "./pg-updbasicinfo.vue?vue&type=template&id=0f496fa2&scoped=true"
import script from "./pg-updbasicinfo.vue?vue&type=script&lang=js"
export * from "./pg-updbasicinfo.vue?vue&type=script&lang=js"
import style1 from "./pg-updbasicinfo.vue?vue&type=style&index=1&id=0f496fa2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f496fa2",
  null
  
)

export default component.exports